import {FieldNode, ReportDefinitionV1} from '../contracts/report-definition.types';

/** Flattens a field tree to its leaf dot-paths, in tree order (depth-first).
 *
 * The leaves ARE the report's columns: what the table renders, what the Columns dropdown offers,
 * and the keys the row mapper files each cell under. It lives here, apart from any of those three,
 * so the mapper can read it without pulling the table's React dependencies into a pure data module. */
export function flattenFieldPaths(fields: FieldNode[]): string[] {
	const paths: string[] = [];

	const visit = (node: FieldNode, prefix: string): void => {
		const path = prefix ? `${prefix}.${node.name}` : node.name;
		if (node.children && node.children.length > 0) {
			for (const child of node.children) {
				visit(child, path);
			}
		} else {
			paths.push(path);
		}
	};

	for (const field of fields) {
		visit(field, '');
	}

	return paths;
}

/** The field-tree root of the task grain, and the fallback for a definition that names none. */
export const TASK_GRAIN_ROOT = 'task';

/** The field-tree root a definition's rows and columns are keyed under - `task`, `projectStatus`.
 *
 * A definition with no fields keeps `task`, which is what an absent grain has always meant. Read
 * from the definition rather than from a returned row: a fetch that nests its rows renames them, so
 * the row cannot be trusted to say what it is. */
export function grainRootOf(definition: Pick<ReportDefinitionV1, 'fields'>): string {
	return definition.fields?.[0]?.name ?? TASK_GRAIN_ROOT;
}
